import { Props } from '../Content/Large';
export { default } from './Strategy';

export type { Props, Props as StratTabNavProps };
